export default {
      id: "i-compass-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/sprite.svg#i-compass",
      toString: function () {
        return this.url;
      }
    }